'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getHeaderRowFromWorkbook;

var _xlsx = require('xlsx');

var _xlsx2 = _interopRequireDefault(_xlsx);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getHeaderRowFromWorkbook(workbook) {
  try {
    var sheet = workbook.Sheets[workbook.SheetNames[0]];
    var headers = [];

    var range = _xlsx2["default"].utils.decode_range(sheet['!ref']);

    var C = void 0;
    /* start in the first row */

    var R = range.s.r;
    /* walk every column in the range */
    // eslint-disable-next-line no-plusplus

    for (C = range.s.c; C <= range.e.c; ++C) {
      /* find the cell in the first row */
      var cell = sheet[_xlsx2["default"].utils.encode_cell({
        c: C,
        r: R
      })];

      var hdr = 'UNKNOWN ' + C; // <-- replace with your desired default

      if (cell && cell.t) hdr = _xlsx2["default"].utils.format_cell(cell);
      headers.push(hdr);
    }

    return headers;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return [];
  }
}